import React from "react";
import { useTranslation } from "react-i18next";
import style from "./FinishedScreen.module.css";

import Icon from "@/ui/icon/Icon";
import Container from "@/layouts/container/Container";
import { Link } from "react-router-dom";

function FinishedScreen({ points, maxPoints }) {
	const { t } = useTranslation();
	const percentage = Math.floor((points / maxPoints) * 100);

	const message =
		percentage >= 90
			? t("quiz:finished.excellent")
			: percentage >= 70
			? t("quiz:finished.veryGood")
			: percentage >= 50
			? t("quiz:finished.good")
			: percentage >= 30
			? t("quiz:finished.couldBeBetter")
			: t("quiz:finished.tryAgain");

	return (
		<Container size="medium">
			<div className={style.finishedHolder}>
				<Link to="/" className={style.goBack}>
					<Icon icon="fa-arrow-left" />
				</Link>
				<div className={style.quizResults}>
					<h2>{t("quiz:finished.title")}</h2>
					<div className={style.statsHolder}>
						<div className={style.statPresenter}>
							<div className={style.header}>
								<span>{message}</span>
							</div>
							<div className={style.body}>
								<Icon icon="fa-bullseye-arrow" />
								<span>{percentage}%</span>
							</div>
						</div>
						<div className={style.statPresenter}>
							<div className={style.header}>
								<span>{t("quiz:finished.points")}</span>
							</div>
							<div className={style.body}>
								<Icon icon="fa-bolt" />
								<span>{points}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
}

export default FinishedScreen;
